import React, { Component } from "react";
import { homeStoreSelectors } from "../../store/store";
import { connect } from "react-redux";
import { SubAppConfig } from "../../../../reducers/subAppsConfig.reducer";
import TopbarItem from "./TopbarItem/TopbarItem.component";
import _ from "lodash";

import "./Topbar.component.scss";
import { HomeActionCreators } from "../../actions/actionCreators";
import { ActionCreator } from "../../../../actions/actions";
import LoggedInUser from "./LoggedInUser/LoggedInUser.component";
import HeaderBackground from "./../../../../utils/HeaderBackground/HeaderBackground.component";
import { Dialog } from "../../../../utils/Dialog/Dialog.component";
import Notifications from "../Notifications/Notifications.component";
import { User } from "../../../auth/reducers/users.reducer";

import {
    Link,
    Redirect,
    withRouter,
    RouteComponentProps
} from "react-router-dom";
import {
    checkPermission,
    isAdmin
} from "../../../../utils/Authorization/authorization";

export interface TopbarProps extends RouteComponentProps {
    activeSubApps: SubAppConfig[];
    selectedSubApp: SubAppConfig;
    selectSubApp: ActionCreator;
    userInfo: User;
}

export interface TopbarState {
    selectedSubApp: SubAppConfig;
    showNotifications: boolean;
    showAdminMenu: boolean;
}

class Topbar extends Component<TopbarProps, TopbarState> {
    private initialRedirect: boolean = false;

    constructor(props) {
        super(props);

        this.state = {
            selectedSubApp: undefined,
            showNotifications: false,
            showAdminMenu: false
        };
    }

    setShowNotifications = toggle => {
        this.setState({
            showNotifications: toggle
        });
    };

    renderTopbarItems() {
        const items =
            this.props.activeSubApps &&
            this.props.activeSubApps.length > 0 &&
            this.props.activeSubApps.map(subApp => {
                const itemSelected =
                    this.props.selectedSubApp &&
                    this.props.location.pathname.startsWith(
                        this.props.selectedSubApp.pathname
                    ) &&
                    this.props.selectedSubApp.pathname == subApp.pathname;

                if (
                    (subApp.hasOwnProperty("permissions") &&
                        subApp.permissions.length > 0 &&
                        subApp.permissions.some(permission =>
                            checkPermission(permission)
                        )) ||
                    !subApp.hasOwnProperty("permissions")
                ) {
                    if (
                        subApp.superuser !== true ||
                        (subApp.superuser == true && isAdmin() == true)
                    ) {
                        return (
                            <Link
                                className="topbar-link"
                                key={_.uniqueId()}
                                onClick={() => (this.initialRedirect = false)}
                                to={subApp.pathname}
                            >
                                <TopbarItem
                                    key={_.uniqueId()}
                                    subAppConfig={subApp}
                                    onSelect={() => this.selectSubApp(subApp)}
                                    selected={itemSelected}
                                />
                            </Link>
                        );
                    }
                }

                return null;
            });

        if (
            checkPermission("mailing_list") ||
            checkPermission("list_prog_presets") ||
            checkPermission("subsidiary_logos")
        ) {
            const selectedAdmin =
                this.props.location.pathname.includes("/admin");
            items.push(
                <span
                    className="topbar-link admin"
                    key={_.uniqueId()}
                    onClick={this.selectAdminMenu}
                >
                    <div
                        className={`topbar-item ${
                            selectedAdmin ? "topbar-item-selected" : ""
                        }`}
                    >
                        <div className="topbar-item-desc">Management</div>
                    </div>
                    {this.state.showAdminMenu && (
                        <div className="admin-menu">
                            {checkPermission("mailing_list") && (
                                <Link
                                    className="topbar-link"
                                    key={_.uniqueId()}
                                    to={`/admin/mailing`}
                                >
                                    Mailing Lists
                                </Link>
                            )}

                            {checkPermission("list_prog_presets") && (
                                <Link
                                    className="topbar-link"
                                    key={_.uniqueId()}
                                    to={`/admin/progressives-presets`}
                                >
                                    Progressives Presets
                                </Link>
                            )}

                            {checkPermission("list_prog_presets") && (
                                <Link
                                    className="topbar-link"
                                    key={_.uniqueId()}
                                    to={`/admin/special-prizes-presets`}
                                >
                                    Special Prizes Presets
                                </Link>
                            )}

                            {checkPermission("subsidiary_logos") && (
                                <Link
                                    className="topbar-link"
                                    key={_.uniqueId()}
                                    to={`/admin/subsidiaries`}
                                >
                                    Subsidiary Logos
                                </Link>
                            )}

                            {isAdmin() && (
                                <Link
                                    className="topbar-link"
                                    key={_.uniqueId()}
                                    to={`/admin/system-server-versions`}
                                >
                                    System Server Versions
                                </Link>
                            )}
                        </div>
                    )}
                </span>
            );
        }

        return <div className="topbar-items">{items}</div>;
    }

    selectAdminMenu = () => {
        this.setState({
            showAdminMenu: true
        });
        document.addEventListener("click", this.handleClickOutsideAdminMenu);
    };

    handleClickOutsideAdminMenu = event => {
        if (
            !document.querySelector(`.topbar-link.admin`).contains(event.target)
        ) {
            this.setState({
                showAdminMenu: false
            });
            document.removeEventListener(
                "click",
                this.handleClickOutsideAdminMenu
            );
        }
    };
    selectSubApp(subApp) {
        this.props.selectSubApp(subApp);
    }

    renderRedirects() {
        if (this.initialRedirect) return;

        this.initialRedirect = true;

        const redirectToDefault =
            this.props.location.pathname === "/" ||
            this.props.location.pathname === "/login";

        const redirectToSelected =
            this.props.selectedSubApp &&
            this.props.selectedSubApp.pathname &&
            !this.props.location.pathname.startsWith(
                this.props.selectedSubApp.pathname
            );

        const redirectToSubApp =
            !this.props.selectedSubApp &&
            !redirectToDefault &&
            !redirectToSelected &&
            !!this.props.activeSubApps.find(subApp =>
                this.props.location.pathname.startsWith(subApp.pathname)
            );

        if (redirectToDefault) {
            const defaultApp =
                this.props.activeSubApps.find(subApp => subApp.default) ||
                this.props.activeSubApps[0];

            if (!defaultApp) {
                return null;
            }

            this.selectSubApp(defaultApp);

            return <Redirect to={defaultApp.pathname} />;
        } else if (redirectToSelected) {
            return <Redirect to={this.props.selectedSubApp.pathname} />;
        } else if (redirectToSubApp) {
            const app = this.props.activeSubApps.find(subApp =>
                this.props.location.pathname.startsWith(subApp.pathname)
            );

            this.selectSubApp(app);

            return <Redirect to={this.props.location.pathname} />;
        }
    }

    /*renderSelectedBar() {
        const shouldRender =
            this.props.selectedSubApp &&
            this.props.selectedSubApp.title &&
            this.props.activeSubApps &&
            this.props.activeSubApps.length > 0;

        if (shouldRender) {
            return (
                <TopbarSelectedBar
                    index={this.props.activeSubApps.indexOf(
                        this.props.activeSubApps.find(
                            subApp =>
                                subApp.title === this.props.selectedSubApp.title
                        )
                    )}
                />
            );
        }
    }*/

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            window.scrollTo(0, 0);
        }
    }

    markAllAsRead = () => {};

    deleteAll = () => {};

    render() {
        return (
            <React.Fragment>
                <Dialog
                    addedClassName="notifications-list"
                    open={this.state.showNotifications}
                >
                    <div>
                        <div className="all-notifications-btns">
                            <button
                                className="close-notifications-btn"
                                onClick={() => this.setShowNotifications(false)}
                            >
                                <i className="icon-times-light"></i>
                            </button>
                            <div>
                                <button
                                    className="delete-notifications-btn"
                                    onClick={this.deleteAll}
                                >
                                    <i className="icon-trash-alt-light"></i>
                                </button>
                                <button
                                    className="mark-notifications-btn"
                                    onClick={this.markAllAsRead}
                                >
                                    Mark all as read
                                </button>
                            </div>
                        </div>
                        {/*<div className="empty"> No new notifications</div>*/}
                        <Notifications notifications={[]} />
                    </div>
                </Dialog>
                <div
                    id="Topbar"
                    className={`${
                        this.state.showNotifications ? "blur-in" : "blur-off"
                    }`}
                >
                    <HeaderBackground />
                    <div className="topbar-inner">
                        <div className="topbar-header">
                            <div className="logo-container">
                                <Link to="/">
                                    <img
                                        src="/images/logo_white.png"
                                        alt="WAVE"
                                    />
                                </Link>
                            </div>
							{this.renderTopbarItems()}
							{/*this.renderSelectedBar()*/}
							{this.renderRedirects()}
                            <LoggedInUser
                                setShowNotifications={this.setShowNotifications}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    activeSubApps: homeStoreSelectors.activeSubApps(state),
    selectedSubApp: homeStoreSelectors.selectedSubApp(state),
    userInfo: homeStoreSelectors.userInfo(state)
});

const mapDispatchToProps = {
    selectSubApp: HomeActionCreators.selectSubApp
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Topbar));
